/**
 * DTO object for creation of ReviewSource.
 */
export class ReviewSourceDto {
  id: number;
  name: string;
  reference: string;
  smallLogoURL: string;
  logoURL: string;
}
